import React from "react";
import { useLocation, useNavigate } from "react-router";
import { Typography, Stack, Button, CircularProgress, Alert, Snackbar } from "@mui/material";
import Section from "src/components/Section";
import CustomStepper from "src/components/CustomStepper";
import PageHeader from "src/components/PageHeader";
import { getPropertyTypeLabel } from "src/utils/labels";
import ConfirmItem from "./components/ConfirmItem";
import { useConfirmPage } from "./hooks";

export default function ConfirmPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { formData, sending, submitAssessment, error, clearError } = useConfirmPage();

  return (
    <>
      <PageHeader title="高精度不動産AI査定" px={0}>
        <Typography fontWeight="bold" textAlign="center">
          入力内容をご確認の上、
          <br />
          よろしければ下のボタンをクリックしてください。
        </Typography>
      </PageHeader>

      {/* 入力確認セクション */}
      <Section>
        <Stack spacing={4}>
          <CustomStepper activeStep={2} />
          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              物件概要
            </Typography>
            <ConfirmItem label="物件種別" value={getPropertyTypeLabel(formData.property_type)} required />
            <ConfirmItem label="市区町村" value={formData.city_ward_town_village} required />
            <ConfirmItem label="地区名" value={formData.district} required />
            <ConfirmItem label="最寄駅" value={formData.station_name} required />
            <ConfirmItem label="駅徒歩（分）" value={formData.station_walk_minutes} required />
            <ConfirmItem label="専有面積（㎡）" value={formData.area} required />
            <ConfirmItem label="築年" value={formData.construction_year} required />
            {/* <ConfirmItem label="建物の構造" value={getStructureTypeLabel(formData.structure)} required /> */}
            {/* <ConfirmItem label="実売価格（百万円単位）" value={formData.actual_sales_price} required /> */}
            <ConfirmItem label="マンション名" value={formData.building_name} required />
            {/* <ConfirmItem label="建蔽率（%）" value={formData.building_coverage_ratio} optional />
            <ConfirmItem label="容積率（%）" value={formData.floor_area_ratio} optional />
            <ConfirmItem label="取引時期" value={formData.transaction_timing} optional />
            <ConfirmItem label="都市計画（用途地域）" value={getCityPlanningLabel(formData.city_planning)} optional />
            <ConfirmItem label="間取り" value={getLayoutLabel(formData.layout)} optional />
            <ConfirmItem label="改装の有無" value={getRenovationLabel(formData.renovation)} optional /> */}
          </Stack>

          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              お客様情報
            </Typography>
            <ConfirmItem
              label="名前"
              value={`${formData.last_name || ""} ${formData.first_name || ""}`.trim()}
              required
            />
            <ConfirmItem label="電話番号" value={formData.phone_number} required />
            <ConfirmItem label="メールアドレス" value={formData.email} required />
            <ConfirmItem label="備考" value={formData.remarks} optional />
          </Stack>

          <Stack spacing={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={submitAssessment}
              disabled={sending}
              startIcon={sending && <CircularProgress size={20} color="inherit" />}
            >
              {sending ? "査定中..." : "AI査定結果を見る"}
            </Button>
            <Button
              fullWidth
              sx={{ backgroundColor: "#B1B1B1" }}
              onClick={() =>
                navigate({
                  pathname: "/input_personal",
                  search: location.search,
                })
              }
              disabled={sending}
            >
              戻る
            </Button>
          </Stack>
        </Stack>
      </Section>
      <Snackbar
        open={Boolean(error)}
        autoHideDuration={5000}
        onClose={clearError}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={clearError} severity="error" variant="filled" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}
